import { render, staticRenderFns } from "./Mailbox.vue?vue&type=template&id=0475a05d"
import script from "./Mailbox.vue?vue&type=script&lang=ts"
export * from "./Mailbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports